import { makeObservable, observable, action, computed } from "mobx";
import { v4 as uuid } from "uuid";

import { AlertCircle, AlertTriangle } from "lucide-react";
import { TaskIcon } from "@/components/icons/TaskIcon";

export class NotificationStore {
  items = [];

  constructor(rootStore) {
    makeObservable(this, {
      items: observable,
      success: action,
      visible: computed,
      hide: action,
    });

    this.rootStore = rootStore;
  }

  get visible() {
    return this.items.filter((i) => i.visible);
  }

  hide(id) {
    const notification = this.items.find((i) => i.id === id);
    notification.visible = false;
    return notification;
  }

  task(options) {
    return this.add({
      ...options,
      type: "task",
      icon: TaskIcon,
      color: "text-blue-400",
    });
  }

  error(options) {
    return this.add({
      ...options,
      type: "error",
      icon: AlertCircle,
      color: "text-red-400",
    });
  }

  warning(options) {
    return this.add({
      ...options,
      type: "warning",
      icon: AlertTriangle,
      color: "text-orange-400",
    });
  }

  success(options) {
    return this.add({
      ...options,
      type: "success",
      icon: CheckCircleIcon,
      color: "text-green-400",
    });
  }

  add(options) {
    const item = {
      id: uuid(),
      visible: true,
      ...options,
    };

    this.items = [item, ...this.items];
    return item;
  }
}
